import { render, staticRenderFns } from "./TreatmentPlanUomMismatchDialog.vue?vue&type=template&id=04ec3d60&lang=pug&"
import script from "./TreatmentPlanUomMismatchDialog.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanUomMismatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports